import makeReloadDataMixin from './make-reload-data-mixin'

export default makeReloadDataMixin([
  state => state.fieldRecordSystem.navigation.location.orgUnitId
])
